import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import useStore, { selectCountryTheme, selectFavoriteCountryId } from '@/hooks/client/useStore';
import { useNavigate } from '@tanstack/react-router';
import SecondaryButton from '@/common/SecondaryButton';
import { useState } from 'react';
import PropTypes from 'prop-types';

const css = {
  card: {
    maxWidth: 400,
    width: '100%',
    mx: 'auto',
    overflow: 'scroll',
    border: 'none',
    boxShadow: 'none',
  },
  headerWrapper: (color) => ({
    position: 'absolute',
    top: 10,
    left: 10,
    backgroundColor: color,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    px: 2,
    py: 1,
    borderRadius: 3,
  }),
  cardTitle: (color) => ({
    mt: 3,
    mb: 2,
    fontWeight: '500',
    color: color,
    overflow: 'auto',
    height: '3.2rem',
    scrollbarWidth: '0',
    fontSize: '18px',
  }),
  cardImg: { borderRadius: 4 },
};

const RecipeCard = ({ card }) => {
  const countryTheme = useStore(selectCountryTheme);
  const countryCode = useStore(selectFavoriteCountryId);
  const navigate = useNavigate();
  const handleShowRecipe = () => navigate({ to: '/recipe/$id', params: { id: card?.id } });
  const [imgSource, setImgSource] = useState(`/images/${countryCode}/recipes/${card.id}.webp`);

  return (
    <Card sx={css.card}>
      <Box position={'relative'}>
        <CardMedia
          component="img"
          loading="lazy"
          height="220vh"
          image={imgSource}
          alt="Imagen de receta"
          onError={() => setImgSource(`/images/${countryCode}/recipes/base.webp`)}
          sx={css.cardImg}
        />
        <Box sx={css.headerWrapper(countryTheme.navColor)}>
          <Box
            component="img"
            loading="lazy"
            sx={{ mr: 0.5, width: '20px', height: '18px' }}
            src={`/images/common/${card?.icon}.svg`}
            alt="Icon"
          />
          <Typography variant="body2">{card?.chickenPiece}</Typography>
        </Box>
      </Box>
      <CardContent sx={{ padding: 0 }}>
        <Typography variant="h3" sx={css.cardTitle(countryTheme.navColor)}>
          {card?.title}
        </Typography>

        {/* read recipe */}
        <SecondaryButton text={'Ver receta'} outlined={true} onClick={handleShowRecipe} />
      </CardContent>
    </Card>
  );
};

RecipeCard.propTypes = {
  card: PropTypes.object.isRequired,
};

export default RecipeCard;
